module.exports = {
      id: "alert-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.b9c19baa.svg#alert-usage",
      toString: function () {
        return this.url;
      }
    }